import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/dao/historic/page.tsx");
